module.exports = set

/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */
function set(out, x, y) {
    out[0] = x
    out[1] = y
    return out
}


//////////////////
// WEBPACK FOOTER
// ./~/gl-vec2/set.js
// module id = 724
// module chunks = 0